import type { PayloadAction } from '@reduxjs/toolkit';
import { initialState } from './constants';
import type { A2HSStorage } from './interface';

const reset = (state: A2HSStorage, action: PayloadAction): A2HSStorage => ({
    ...initialState,
});

const updateHeadingText = (state: A2HSStorage, newText: PayloadAction<string>): A2HSStorage => ({
    ...state,
    heading: {
        ...state.heading,
        text: String(newText.payload),
    },
});

const updateSubHeadingText = (state: A2HSStorage, newText: PayloadAction<string>): A2HSStorage => ({
    ...state,
    heading: {
        ...state.heading,
        text: String(newText.payload),
    },
});

export type NamedTypes = keyof typeof module;

export default Object.freeze({
    reset,
    updateHeadingText,
    updateSubHeadingText,
});
